import getPolygonReportDoc from "./document";

export default getPolygonReportDoc;
export * from "./types";
